import { render, staticRenderFns } from "./bao-cao-doanh-thu.vue?vue&type=template&id=29410c83&scoped=true&"
import script from "./bao-cao-doanh-thu.vue?vue&type=script&lang=js&"
export * from "./bao-cao-doanh-thu.vue?vue&type=script&lang=js&"
import style0 from "./bao-cao-doanh-thu.vue?vue&type=style&index=0&id=29410c83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vbimex/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29410c83",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../vbimex/admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VDataTable,VDatePicker,VFlex,VLayout,VMenu,VTextField})
